import { render, staticRenderFns } from "./branchesList.vue?vue&type=template&id=a33f6d94&scoped=true&"
import script from "./branchesList.vue?vue&type=script&lang=js&"
export * from "./branchesList.vue?vue&type=script&lang=js&"
import style0 from "./branchesList.vue?vue&type=style&index=0&id=a33f6d94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a33f6d94",
  null
  
)

export default component.exports